import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Menu.css";
import Logo from "./../../images/LAE.png";
import UserMenu from "../navbar/UserMenu";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTranslation } from 'react-i18next';
import VisitQueueNav from "../navbar/VisitQueueNav";
import BotonNavChatElite from "../ChatElite/panel/BotonNavChatElite";

const Menu = ({ menu, routesClientes, routesPersonal, routesListados, routesDashboard, routesKae }) => {
  const { t } = useTranslation(['common', 'nav']);
  const [navExpanded, setNavExpanded] = useState(false);

  const sections = [
    { key: 'clients', content: routesClientes, label: t('menu.clients', { ns: 'nav' }) },
    { key: 'staff', content: routesPersonal, label: t('menu.staff', { ns: 'nav' }) },
    { key: 'alerts', content: menu, label: t('menu.alerts', { ns: 'nav' }) },
    { key: 'reports', content: routesListados, label: t('menu.reports', { ns: 'nav' }) },
    { key: 'dashboard', content: routesDashboard, label: t('menu.dashboard', { ns: 'nav' }) },
    { key: 'kae', content: routesKae, label: t('menu.kae', { ns: 'nav' }) },
  ];

  const toggleNav = () => {
    setNavExpanded(prev => !prev);
  };

  const closeNav = () => {
    setNavExpanded(false);
  };

  return (
    <>
      <div className="mobile-navbar sticky-top bg-topNavbar">
        <div className="mobile-navbar-top">
          <div className="mobile-navbar-left">
            <button type="button" className="mobile-toggle" onClick={toggleNav}>
              <div className={`animated-icon1 ${navExpanded ? 'open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
            <Link to="/" style={{ display: "flex", cursor: "pointer" }}>
              <img
                src={Logo}
                alt="logo"
                style={{
                  width: "60px",
                  filter: "brightness(0) invert(1)",
                  marginLeft: 5,
                  display: "block",
                }}
              />
            </Link>
          </div>
          <div className="mobile-navbar-right">
            <BotonNavChatElite movil />
            <LanguageSwitcher isMobile={true} />
            <UserMenu isMobile={true} />
          </div>
        </div>

        {navExpanded && (
          <div className="mobile-menu-content bg-topNavbar" onClick={closeNav}>
            <ul className="mobile-menu-list">
              <VisitQueueNav />
              {sections.map(({ key, content, label }) =>
                content ? (
                  <React.Fragment key={key}>
                    <li className="mobile-menu-section-header">{label}</li>
                    {content}
                  </React.Fragment>
                ) : null
              )}
            </ul>
            <div>
              <div className="navbar-info">{t('nav.legalNotice', { ns: 'common' })}</div>
              <div className="navbar-info">{t('nav.developedBy', { ns: 'common' })}</div>
            </div>
          </div>
        )}
      </div>
      <style jsx="true">{`
        .dropdown-toggle:after {
          display: none !important;
        }
      `}</style>
    </>
  );
};

export default Menu;
